import { lighten } from "@mui/material";
import { boxGrey, darkBlue } from "../../constants/ColourConstants";
import { styles as mainStyles } from "../styles";

export const styles = {
  backgroundBox: {
    width: { xs: "90%", md: "80%" },
    mx: "auto",
    my: 3,
    p: { xs: 2, md: 4 },
    background: boxGrey,
    borderRadius: 2,
  },
};

export const checkboxStyles = {
  width: "100%",
  "& .MuiCheckbox-root": {
    pl: 0,
    py: 0,
    color: darkBlue,
  },
  "& .MuiCheckbox-root.Mui-checked": {
    color: darkBlue,
  },
  "& .MuiCheckbox-root:hover": {
    color: lighten(darkBlue, 0.15),
  },
  "& .MuiFormControlLabel-root": {
    mx: 0,
    p: "5px 0",
    alignItems: { xs: "flex-start", md: "center" },
  },
  "& .MuiFormControlLabel-label": {
    ...mainStyles.leftAlignedTypographyBody,
  },
};
